import { render } from "./PurchaseInvoiceFileItem.vue?vue&type=template&id=64e1ed9d&scoped=true"
import script from "./PurchaseInvoiceFileItem.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoiceFileItem.vue?vue&type=script&lang=js"

import "./PurchaseInvoiceFileItem.vue?vue&type=style&index=0&id=64e1ed9d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e1ed9d"]])

export default __exports__